import PaymentContainerClient from "../../PaymentContainerClient";
import ConfirmedFailedPaymentDto from "../../PaymentContainerClient/dtos/ConfirmFailedPaymentResponseDto";
import ConfirmSuccessPaymentResponseDto from "../../PaymentContainerClient/dtos/ConfirmSuccessPaymentResponseDto";
import { GainsightEvent, trackEvent } from "../common/gainsight";

export const confirmPayment = async (
    token: string,
    jwtToken: string
): Promise<ConfirmSuccessPaymentResponseDto | ConfirmedFailedPaymentDto> => {
    const paymentContainerClient = new PaymentContainerClient();

    const confirmPaymentData = await paymentContainerClient.confirmPayment(
        token,
        jwtToken
    );

    trackEvent(GainsightEvent.ConfirmPayment);

    return confirmPaymentData;
};
